import { BarChart, ShowChart } from "@mui/icons-material";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";

export type PeriodChartStyle = "line" | "bars";

interface PeriodChartStyleToggleProps {
  value: PeriodChartStyle;
  onChange: (style: PeriodChartStyle) => void;
  disabled?: boolean;
}

/**
 * Alterna a visão de período: gráfico de linha (KPIs + detalhe) ou barras
 * (cartões por métrica — modo anterior).
 */
export function PeriodChartStyleToggle({
  value,
  onChange,
  disabled = false,
}: PeriodChartStyleToggleProps) {
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      disabled={disabled}
      onChange={(_event, next: PeriodChartStyle | null) => {
        if (next) onChange(next);
      }}
      sx={{
        flexShrink: 0,
        maxWidth: "100%",
        "& .MuiToggleButton-root": {
          px: { xs: 1, sm: 1.25 },
          py: 0.5,
          textTransform: "none",
          fontWeight: 600,
          fontSize: "0.75rem",
          gap: 0.5,
        },
      }}
    >
      <ToggleButton value="line" aria-label="Gráfico de linha">
        <ShowChart fontSize="small" />
        {/* No mobile, o ícone mantém o seletor compacto na faixa de filtros. */}
        <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
          Linha
        </Box>
      </ToggleButton>
      <ToggleButton value="bars" aria-label="Gráfico de barras">
        <BarChart fontSize="small" />
        <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
          Barras
        </Box>
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
